import { heroQuickCards } from "@/mocks/homeData";

export default function HeroSection() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=minimal%20warm%20abstract%20geometric%20grid%20and%20flowing%20lines%20on%20soft%20cream%20beige%20background%2C%20clean%20editorial%20tech%20aesthetic%2C%20subtle%20amber%20and%20green%20accents%2C%20high%20key%20bright%20modern%20banner&width=1920&height=1080&seq=91hero-bg&orientation=landscape"
          alt="91网入口汇总页面背景"
          title="91网最新地址与可用入口汇总"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/85 via-background-50/70 to-background-50/95"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 pt-28 pb-14 md:pt-36 md:pb-20">
        <div className="flex flex-col items-center text-center max-w-4xl mx-auto animate-fade-up">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-background-100 border border-background-200 text-xs text-foreground-700 mb-5">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
            入口汇总页 · 持续同步最新可用地址
          </span>
          <h1 className="font-heading font-bold text-2xl md:text-4xl leading-snug text-foreground-950">
            91网入口怎么找？官网网址打不开？最新地址怎么获取？看这里全搞定
          </h1>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700 max-w-2xl">
            本页汇总 91网 最新入口、官网地址与可用网址，专门解决网站打不开、入口找不到的问题。首次访问或需要找回收藏，都能在这里快速拿到有效链接。
          </p>
          <div className="mt-7 flex flex-col sm:flex-row items-center gap-3">
            <a
              href="#entries"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-flashlight-line"></i>
              立即速查可用入口
            </a>
            <a
              href="#troubleshoot"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-background-300 bg-background-50/80 text-foreground-900 text-sm font-medium hover:border-primary-300 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-tools-line"></i>
              打不开？先看排查步骤
            </a>
          </div>
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {heroQuickCards.map((card, index) => (
            <div
              key={card.id}
              className="group bg-background-50 rounded-lg border border-background-200 overflow-hidden flex flex-col animate-fade-up"
              style={{ animationDelay: `${index * 80}ms` }}
            >
              <div className="relative w-full h-32 overflow-hidden">
                <img
                  src={card.cover}
                  alt={`${card.title} 示意配图`}
                  title={`${card.title} - 91网入口指引`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-2.5 left-2.5 px-2 py-0.5 rounded-full bg-background-50/90 text-[11px] text-primary-700 font-medium">
                  {card.tag}
                </span>
              </div>
              <div className="p-4 flex flex-col gap-2 flex-1">
                <div className="flex items-center gap-2">
                  <span className="w-7 h-7 rounded-md bg-background-100 text-primary-600 flex items-center justify-center">
                    <i className={`${card.icon} text-base`}></i>
                  </span>
                  <h4 className="font-heading font-semibold text-sm text-foreground-950">{card.title}</h4>
                </div>
                <p className="text-xs leading-relaxed text-foreground-600">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}